import * as React from 'react';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { outlinedInputClasses } from '@mui/material';
import { getRequest, postRequest, putRequest } from "../../services/ApiServices";
import { useState, useEffect } from "react";
import { ToastError, ToastSuccess } from "../../services/ToastMsg";
import { getCookie } from "../../services/Cookies";
import { FilterObj } from '../CommonComponents/globalfilterObj';
export default function Voltage(props) {
    const [GlobalFilterSettingValue, setGlobalFilterSettingValue] = React.useState(localStorage.getItem('GlobalFilterSetting'));
    const { globalfilter, screen, updateParent,reset, type } = props;
    const [formObj, setFormObj] = useState(FilterObj);
    const [VoltageData, setVoltageData] = React.useState([]);
    const [selectedvalue, setselectedvalue] = React.useState([]);
    const [filteredString, setValue] = useState("");
    const fetchVoltageData = async (event) => {
        const searchStr = event.target.value;
        setValue(searchStr);
        const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `CommonComponent/TOTVoltage/${searchStr}`;

        await getRequest(url)
            .then((res) => {
                console.log("Responce", res);
                if (res.status == 200) {
                    //let obj = { "voltage": "All" };
                    let data = res.data;
                    let result = data?.map((a, i) => { 
                        return { id: a?.id, name: a?.title };
                    });
                    if (selectedvalue) {
                        selectedvalue.forEach((val, i) => {
                            result = result.filter((ele) => ele.name != val.name)
                        })
                    }
                    setVoltageData(result);
                } else {
                    ToastError(res.data.message);
                }
            })
            .catch((error) => {
                // dispatch({ type: LOADING, payload: false });
                //console.log(error);
                // ToastError(error.response.data.message);
            });
    }
    const handleChange = (event,newValue) => {
        props.onChange(newValue)
        const filteredTotvoltage = {
            ...formObj,
            Totvoltage: newValue
        };
        setFormObj(filteredTotvoltage);
        setselectedvalue(newValue);
        setValue("");
        if (screen !== "GlobalFilter") {
            let Obj = JSON.parse(localStorage.getItem('TOTFilterSetting'));
            Obj = {
                ...Obj,
                Totvoltage: newValue
            }
            localStorage.setItem("TOTFilterSetting", JSON.stringify(Obj));
        }
    }
    const defaultValue = (val) => {
        ////
        let filtervalue = JSON.parse(localStorage.getItem('TOTFilterSetting'));
        if (filtervalue !== "" && filtervalue !== undefined && filtervalue !== null && filtervalue !== "null" && screen !== "GlobalFilter") {
            const Obj = {
                ...formObj,
                Totvoltage: filtervalue.Totvoltage
            };
            setFormObj(Obj);
            setselectedvalue(filtervalue.Totvoltage);
        }
        else if (val !== "" && val !== undefined && val !== "null") {
            let Obj = JSON.parse(val);
            setFormObj(Obj);
            setselectedvalue(Obj.Totvoltage);
            console.log('getcookievalue',formObj)
        }else{
            setFormObj({});
        }
      }
      React.useEffect(() => {
        //
        if (reset>0)
        defaultValue(GlobalFilterSettingValue);
        
    }, [reset]);
    React.useEffect(() => {
        ////
        defaultValue(GlobalFilterSettingValue);
    }, []);
    return (
        <Stack spacing={3}>


            <Autocomplete
                multiple
                id="size-small-standard-multi"
                size="small"
                // fullWidth Totvoltage
                value={formObj?.Totvoltage || []}
                getOptionSelected={(option, value) => option?.name === value?.name}
                options={VoltageData}
                getOptionLabel={(option) => option?.name}
                //defaultValue={[top100Films[13]]}
                // onChange={(event, newValue) => {
                //     //

                // }}
                onChange={(event, newValue) => handleChange(event, newValue)}
                inputValue={filteredString}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="standard"
                        label="Voltage"
                        placeholder=""
                        onChange={fetchVoltageData}

                    />
                )}
            />


        </Stack>
    );
}

// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top

